<template> 
        <CRow>
            <CCol>
                <ejs-grid ref='grid' 
                          :dataSource='data' 
                          :allowFiltering='true' 
                          :allowPaging='true' 
                          :allowResizing='true' 
                          :allowReordering='true' 
                          :allowSorting='true' 
                          :toolbar='toolbar' 
                          :pageSettings='pageSettings' 
                          :filterSettings='filterOptions' 
                          :toolbarClick='toolbarClick' 
                          :allowExcelExport='true' 
                          :excelExportComplete='excelExportComplete'
                          :query='query'
                          :recordDoubleClick="recordDoubleClick">
                    <e-columns>
                        <e-column field='clientId' headerText='Id' :isPrimaryKey='true' :visible='true'></e-column>
                        <e-column field='clientName' headerText='Name' width=160></e-column>
                        <e-column field='consultant' headerText='Consultant' width=120></e-column>
                        <e-column field='clientCoordinatorName' headerText='Coordinator' width=120 ></e-column>
                        <e-column field='status' headerText='Status' width=120></e-column>
                        <e-column field='fiscalMonthName' headerText='Fiscal Year - End Month' width=120 ></e-column>
                    </e-columns>
                </ejs-grid>
            </CCol>
        </CRow>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import gridOptions from '@/common/gridOptions'
    import SyncHelper from '@/common/syncfusion'
    import apis from '@/common/network'

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);


    export default {
        name: 'MyClients',
        data() {
            return {
                data: SyncHelper.getDataManager("client"),
                pageSettings: gridOptions.pageSettings,
                toolbar: [{ text: 'Add', tooltipText: 'Add', prefixIcon: 'e-add', id: 'AddClient' },
                          { text: 'Edit', tooltipText: 'Edit', prefixIcon: 'e-edit', id: 'EditClient' },
                          { text: 'Delete', tooltipText: 'Delete', prefixIcon: 'e-delete', id: 'DeleteClient' },
                          'ExcelExport'],
                filterOptions: gridOptions.filterSettings,
            }
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id === 'AddClient') {
                    this.$router.push({ name: "Client"});
                }
                if (args.item.id === 'EditClient') {
                    let selectedClient = this.$refs.grid.getSelectedRecords();
                    if (selectedClient.length > 0) {
                        this.$router.push({ name: "Client", params: { clientId: selectedClient[0].clientId } });
                    } else {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: "Please, choose a client first",
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' }
                        });
                    }
                }
                if (args.item.id === 'DeleteClient') {
                    let selectedClient = this.$refs.grid.getSelectedRecords();
                    if (selectedClient) {
                        apis.protectedApi.delete(`client/${selectedClient[0].clientId}`)
                            .then(response => {
                                this.$refs.grid.refresh()
                            }).catch(e => {
                                DialogUtility.alert({
                                    title: 'Alert Dialog',
                                    content: e.response.data.message,
                                    position: { X: 700, Y: 200 },
                                    showCloseIcon: true,
                                    closeOnEscape: true,
                                    animationSettings: { effect: 'Zoom' }
                                });
                            });
                    }
                }
                if (args.item.id.indexOf("excelexport") !== -1) {
                    gridOptions.excelExport(args, "Clients.xlsx", this.$refs);
                }
            },
            recordDoubleClick: function (e) {
                 this.$router.push({ name: "Client", params: { clientId: e.rowData.clientId } });                
            }, 
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            }
        },
        computed: {
            query: function () {
                return new Query().addParams("userId", this.$store.state.loggedInUserId);
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    } 
</script>

<style scoped>
</style>